import { Directive, ElementRef, Output, EventEmitter, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[clickOutside]',
    standalone: true
})
export class ClickOutsideDirective {
    clickOutsideExclusion: Array<string> = new Array<string>();

    @Input('clickOutside') set exclusion(array: Array<string>) {
        this.clickOutsideExclusion = array.slice();
    };

    @Output() clickOutside: EventEmitter<void> = new EventEmitter<void>();

    constructor(private _elementRef: ElementRef) {}

    private _isContainsClass(target: any, classList: Array<string>): boolean {
        if (!classList.length) return false;

        const condition: boolean = classList.some(item => target.classList.contains(item));

        if (!condition && target.parentElement) {
            return this._isContainsClass(target.parentElement, classList);
        } else {
            return condition;
        }
    }

    @HostListener('document:mousedown', ['$event'])
    public onClick(event: MouseEvent) {
        if (event.which !== 1) return;
        const clickedInside: boolean = this._elementRef.nativeElement.contains(event.target);
        if (clickedInside) return;
        if (!this._isContainsClass(event.target, this.clickOutsideExclusion) && !clickedInside)
            this.clickOutside.emit();
    }

    @HostListener('document:touch', ['$event.target'])
    public onTouch(target: TouchEvent) {
        const clickedInside: boolean = this._elementRef.nativeElement.contains(target);
        if (!clickedInside) this.clickOutside.emit();
    }
}